import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { IndianRupee, CalendarClock, PhoneCall, ArrowUpRight } from 'lucide-react';
import api from '../../lib/api';

const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';
const fmtInr = (n) => n == null ? null : `₹${Number(n).toLocaleString('en-IN')}`;

export const RazorpayBillingTile = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/api/subscriptions/razorpay-summary')
      .then((res) => setData(res.data))
      .catch(() => setData(null));
  }, []);

  if (!data?.is_razorpay) return null;

  const active = ['active', 'trialing'].includes(data.billing_status);
  const interval = data.billing_interval === 'annual' ? 'yr' : 'mo';

  return (
    <Card data-testid="razorpay-billing-tile" className="border-2 border-emerald-500/60 bg-emerald-50/40 dark:bg-emerald-950/20">
      <CardContent className="py-4">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-emerald-100 dark:bg-emerald-900/50 flex items-center justify-center">
              <IndianRupee className="h-6 w-6 text-emerald-700 dark:text-emerald-300" />
            </div>
            <div>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-semibold" data-testid="razorpay-plan-name">{data.plan_name} plan</span>
                <Badge variant="outline" className="text-xs">Razorpay · India</Badge>
                <Badge className={active ? 'bg-emerald-600 hover:bg-emerald-600' : 'bg-amber-500 hover:bg-amber-500'} data-testid="razorpay-billing-status">
                  {(data.gateway_status || data.billing_status || 'unknown').replace('_', ' ')}
                </Badge>
              </div>
              <p className="text-sm text-muted-foreground mt-1 flex items-center gap-1.5">
                <CalendarClock className="h-3.5 w-3.5" />
                <span data-testid="razorpay-renews-at">Renews {fmtDate(data.renews_at)}</span>
                {fmtInr(data.amount_inr) && <span data-testid="razorpay-amount">· {fmtInr(data.amount_inr)}/{interval} + GST</span>}
              </p>
              {data.pending_upgrade && (
                <p className="text-xs text-amber-700 dark:text-amber-400 mt-1 flex items-center gap-1" data-testid="razorpay-pending-upgrade">
                  <ArrowUpRight className="h-3 w-3" />
                  Upgrade to {data.pending_upgrade.to_plan.replace(/_/g, ' ')} pending payment
                </p>
              )}
            </div>
          </div>
          <div
            className={`flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-medium ${data.voice_live_unlocked ? 'bg-emerald-600 text-white' : 'bg-amber-100 text-amber-800'}`}
            data-testid="razorpay-voice-status"
          >
            <PhoneCall className="h-4 w-4" />
            {data.voice_live_unlocked ? 'LIVE Voice AI unlocked' : `Voice locked: ${(data.voice_blocked_reason || 'check billing').toLowerCase().replace(/_/g, ' ')}`}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
